/**
 * Created by brianschroer on 5/19/16.
 */

//(function () {
//    'use strict';
//
//    // @ngInject
//    function PipelineSettingsIntroControllerCtor($scope, $injector, $modalInstance,
//                                                 AnalyticsService) {
//        this.constructor.$super.call(this, $scope, $injector);
//        this.__objectType = 'Controller';
//
//        this.$modalInstance = $modalInstance;
//        AnalyticsService.trackPageView(this, 'View');
//    }
//
//    Controllers.PipelineSettingsIntroController = Class(Controllers.BaseController, {
//        constructor: PipelineSettingsIntroControllerCtor,
//
//        close: function close() {
//            this.$modalInstance.close(false);
//        },
//
//        letsGo: function letsGo(openSettings) {
//            this.$modalInstance.close(openSettings);
//        }
//    });
//}());
